import type { MonthGroup } from '@/cmsBackend/transformers/types/featureAnnouncement';

/** Parses `#slug` or `slug` from a location hash (decoded, matches nav `encodeURIComponent`). */
export function parseProductUpdatesHashSlug(hash: string): string | null {
  if (!hash) {
    return null;
  }
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!raw) {
    return null;
  }
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function getProductUpdatesHashSlug(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return parseProductUpdatesHashSlug(window.location.hash);
}

export function scrollToAnnouncementSlug(slug: string): boolean {
  const element = document.getElementById(slug);
  if (!element) {
    return false;
  }
  element.scrollIntoView({ block: 'start' });
  return true;
}

export function isSlugInMonthGroups(slug: string, monthGroups: MonthGroup[]): boolean {
  return monthGroups.some((group) => group.majorAnnouncements.some((card) => card.slug === slug));
}
